import { UseQueryOptions } from '@tanstack/react-query';

import APIError from 'types/api_error';
import { Camera } from 'types/camera';
import { Stream, StreamSource, StreamType } from 'types/stream';
import { OffsetPaginated, OffsetPaginationParams } from 'types/pagination';

import { useAPI } from './useAPI';
import { useAuthenticatedQuery } from './useAuthenticatedQuery';
import { TagParams } from '../../tags/types/tagged';

export type VideoSource = Camera | Stream;

export type UseVideoSourcesParams = TagParams & {
  /** Limit response to camera or stream. Defaults to 'all'. */
  fetch_type?: 'all' | 'cameras' | 'streams';
  names?: string[];
  gateway_ids?: string[];
  // Stream filters
  stream_types?: StreamType[];
  stream_sources?: StreamSource[];
  // Camera filters
  conn_types?: Camera['conn_type'][];
};

type UseVideoSourcesOptions = UseQueryOptions<
  OffsetPaginated<VideoSource>,
  APIError
> & {
  params?: UseVideoSourcesParams & OffsetPaginationParams;
};

export function useVideoSources({
  queryKey = ['video-sources'],
  params,
  ...options
}: UseVideoSourcesOptions = {}) {
  const { applicationID, client } = useAPI();

  const queryParams = {
    pagination: 'offset',
    page: 1,
    limit: 50,
    ...params,
  };

  return useAuthenticatedQuery(
    [...queryKey, applicationID, queryParams],
    async () => {
      const { data } = await client.get(
        `/internal/console/${applicationID}/video_sources`,
        {
          params: queryParams,
        }
      );

      return data;
    },
    options
  );
}
